import {
	CMIC_TREE_NODE_TYPES,
	CMIC_MS_PLUGIN_NAMES,
	CMIC_PM_OBJECTS_TYPES,
	CMIC_FIELD_REST__NAMES,
} from '../shared/Constants';
import {
	fetchIssueStatus,
	fetchRFIStatus,
	fetchIssueSeverity,
	fetchIssueType,
	fetchDJRainyDay,
	fetchDJStatus,
} from './grid/helper/StatusFetch';
import { createAPIURLWithParams, handlePageSize } from '../shared/UtilityFunctions';

export const treeItemFetch = async (data, ecmParentNodeType, objServerSettings) => {
	try {
		let _strApiURL = '';
		let argsMap = new Map();

		argsMap.set('username', objServerSettings.usernameAndTenantId);
		argsMap.set('password', objServerSettings.password);

		const requierdSize = handlePageSize(ecmParentNodeType);
		const limit = requierdSize;
		const offset = (data?.num || 0) * limit;
		const orderBy = data?.orderBy || null;
		const filter = data?.filter || '';
		const search = data?.search || '';

		switch (ecmParentNodeType) {
			case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.docTypesWithCount
					}?onlyData=true&totalResults=true&${orderBy ? 'orderBy=' + orderBy + '&' : ''}limit=700&finder=findByFilter;source=${data.value || objServerSettings.value},status=N`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.documenttypes
					}?offset=${offset}&limit=${limit}&totalResults=true&${orderBy ? '&orderBy=' + orderBy + '&' : ''}onlyData=true&finder=selectbyproject;projOraseq=${data.nodeId || objServerSettings.value}`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.getDocumentsForDocumentType
					}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=selectByDocTypeUuid;activeFlag=Y,sourceUuid=${objServerSettings?.ImgsVUuid || data?.ImgsdtSourceUuid || ''
					},submittedFlag=N,docTypeUuid=${data.nodeId || data.value}${filter}`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.getRevisionsForDocument}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=selectByDocumentUuid;docUuid=${data.nodeId || data.value
					}${filter}`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
				argsMap.set('documentId', data?.children[8].value || data?.data?.children[18].value || '');

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ENTERPRISE_REVISIONS_FOR_DOC,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECTS_PARENT:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.projects
					}?limit=${100}&offset=${0}&onlyData=true&finder=searchprojects;searchCriteria=${search || null}`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT:
				const _strParamValueForNoFilterFolder = 'NOFILTER_N';

				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.getProjectFilterFolders}?projectID=${data.value}&rfiFilter=${_strParamValueForNoFilterFolder}&commFilter=${_strParamValueForNoFilterFolder}&issueFilter=${_strParamValueForNoFilterFolder}&sbmtFilter=${_strParamValueForNoFilterFolder}&scFilter=${_strParamValueForNoFilterFolder}&sccoFilter=${_strParamValueForNoFilterFolder}`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
				argsMap.set('projectId', data?.nodeId || data?.key || data?.children[1].value);

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_COMMUNICATION,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.issues}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=selectbyproject;projOraseq=${objServerSettings.value
					}${filter},searchCriteria=${search}`;
				const DmiRecordStatus = (await fetchIssueStatus(objServerSettings)).map(item => ({
					label: item.DmisDesc,
					value: item.DmisStatusCode,
				}));
				const DmiPriorityDesc = (await fetchIssueSeverity(objServerSettings)).map(item => ({
					label: item.DmipDesc,
					value: item.DmipPriorityCode,
				}));
				const DmiTypeCode = (await fetchIssueType(objServerSettings)).map(item => ({
					label: item.DmitDesc,
					value: item.DmitTypeCode,
				}));

				return {
					_strApiURL,
					argsMap,
					statusData: {
						DmiRecordStatus,
						DmiPriorityDesc,
						DmiTypeCode,
					},
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.rfisv12}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=selectbyproject;projOraseq=${objServerSettings.value
					}${filter},searchCriteria=${search}`;
				const PmscrfiStatusDesc = await fetchRFIStatus(objServerSettings);

				return {
					_strApiURL,
					argsMap,
					statusData: {
						PmscrfiStatusDesc,
					},
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.submittals}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=searchbyproject;projOraseq=${objServerSettings.value
					}`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.journals}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&finder=selectbyproject;projOraseq=${objServerSettings.value
					}${filter},searchCriteria=${search}`;

				//  const PmjPrepContactName = await fetchDJPreparedBy(objServerSettings,data.nodeId || data.key);
				const PmjRainDayFlag = fetchDJRainyDay();
				const PmjRecordStatus = fetchDJStatus();

				return {
					_strApiURL,
					argsMap,
					statusData: {
						// PmjPrepContactName,
						PmjRainDayFlag,
						PmjRecordStatus,
					},
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS:
				argsMap.set(
					'projectId',
					data?.nodeId || data.value || data?.children[1].value || data?.data?.children[1].value || '',
				);

				//  Arun - scStatus, scFilter parameters to be reviewed
				argsMap.set('scStatus', 'NOFILTER');
				argsMap.set('scFilter', 'N');

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_SUBCONTRACTORS,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS:
				argsMap.set(
					'projectId',
					data?.nodeId || data?.key || data?.children[1].value || data?.data?.children[1].value || '',
				);

				//  Arun - sccoStatus, sccoFilter parameters to be reviewed
				argsMap.set('sccoStatus', 'NOFILTER');
				argsMap.set('sccoFilter', 'N');

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_SUBCONTRACTORS_CHANGE_ORDERS,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_PCI:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.pcis}?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true`;

				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.documenttypes
					}?offset=${offset}&limit=${limit}&totalResults=true&${orderBy ? '&orderBy=' + orderBy + '&' : ''}onlyData=true&finder=selectbyproject;projOraseq=${objServerSettings.value}`;
				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.doc_for_documenttypes
					}?offset=${offset}&limit=${limit}&totalResults=true&onlyData=true&finder=selectbyproject;typeCode=${data?.PmdgtTypeCode || ''
					},docFileType=,revision=latest,excludeTypeCodes=DRAWMGMT,projOraseq=${objServerSettings.value
					},searchCriteria=${search}`;
				if (orderBy && !orderBy.includes('Version')) _strApiURL += `&orderBy=${orderBy || ''}`;
				else if (orderBy && orderBy.includes('Version')) _strApiURL += `,sortBy=${orderBy || ''}`;
				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.doc_for_documenttypes}/${data.VUuid}/child/DocRevisionView?offset=${offset}&limit=${limit}&onlyData=true&totalResults=true`;
				return {
					_strApiURL,
					argsMap,
				};

			case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
				data = data?.children || data?.data?.children || '';

				argsMap.set('projectId', data ? data[16].value : '');
				argsMap.set('docTypeCode', data ? data[9].value : '');
				argsMap.set('ecmdocOraseq', data ? data[6].value : '');

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_DOC_REVISION_METADATA,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
				data = data?.children || data?.data?.children || '';

				argsMap.set('projectId', data ? data[6].value : '');
				argsMap.set('pObjectId', data ? data[2].value : '');
				argsMap.set('pObjectType', CMIC_PM_OBJECTS_TYPES.PM_TYPE_COMMUNICATION);

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_ATTACHMENTS,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.journals}/${data.VUuid
					}/child/RelatedDocumentView?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&expand=DocRevisionView,DocumentsView`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.issues}/${data.VUuid
					}/child/RelatedDocumentView?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&expand=DocRevisionView,DocumentsView`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_PCI:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.pcis}/${data.VUuid}/child/RelatedDocumentView`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_RFI:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.rfisv12}/${data.VUuid
					}/child/RelatedDocumentView?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&expand=DocRevisionView,DocumentsView`;

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
				data = data?.children || data?.data?.children || '';

				argsMap.set('projectId', data ? data[3].value : '');
				argsMap.set('pObjectId', data ? data[21].value : '');
				argsMap.set('pObjectType', CMIC_PM_OBJECTS_TYPES.PM_TYPE_SUBCONTRACT);

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_ATTACHMENTS,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
				data = data?.children || data?.data?.children || '';

				argsMap.set('projectId', data ? data[20].value : '');
				argsMap.set('pObjectId', data ? data[7].value : '');
				argsMap.set('pObjectType', CMIC_PM_OBJECTS_TYPES.PM_TYPE_SUBCONTRACTS_CHANGE_ORDER);

				_strApiURL = createAPIURLWithParams(
					objServerSettings.serverURL,
					CMIC_MS_PLUGIN_NAMES.GET_ECM_ATTACHMENTS,
					argsMap,
				);

				return {
					_strApiURL,
					argsMap,
				};
			case CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
				_strApiURL = `${objServerSettings.serverURL}${CMIC_FIELD_REST__NAMES.submittals}/${data.VUuid
					}/child/RelatedDocumentView?limit=${limit}${orderBy ? '&orderBy=' + orderBy : ''
					}&offset=${offset}&totalResults=true&onlyData=true&expand=DocRevisionView,DocumentsView`;

				return {
					_strApiURL,
					argsMap,
				};

			default:
				return {
					_strApiURL: '',
					argsMap,
					statusData: {},
				};
		}
	} catch (error) {
		console.log('TreeItemURL.js Error', error);
		return {
			_strApiURL: '',
			argsMap: '',
			statusData: {},
		};
	}
};
